// ControlModel.js

import { Model }            from 'backbone';
import formModel            from 'formModel.js'
import undoService          from 'UndoService.js'
import textConstants        from 'TextConstants';
import constants        from 'Constants';
import eventBus from 'EventBus';
import listService from "../service/ListService";
import mobileSyncService from "../service/mobile/MobileSyncService";

class ControlModel extends Model {

    initialize() {
        this.initDevice = {
            top: this.get('top'),
            left: this.get('left'),
            height: this.get('height'),
            width: this.get('width'),
            isHidden: this.get('isHidden'),
            tabIndex: this.get('tabIndex'),
            tabSettingsTitle : 'Settings',
            displayMode: '',
            maintainAspectRatio: this.get('maintainAspectRatio'),
            stretch: this.get('stretch'),
            assetId: this.get('assetId'),
            tabEnabled: this.get('tabEnabled'),
            gridData: this.get('gridData'),
            tableRowHeight: this.get('tableRowHeight'),
            tableRowMax: this.get('tableRowMax'),
            showHeader: this.get('showHeader'),
            headerHeight: this.get('headerHeight'),
            showButtons: this.get('showButtons'),
            resizableColumns: this.get('resizableColumns'),
            showFooter: this.get('showFooter')
        };

        this.initDeviceTablet = {
            top: this.get('top'),
            left: this.get('left'),
            height: this.get('height'),
            width: this.get('width'),
            isHidden: this.get('isHidden'),
            tabIndex: this.get('tabIndex'),
            tabSettingsTitle : 'Settings',
            displayMode: '- Tablet',
            maintainAspectRatio: this.get('maintainAspectRatio'),
            stretch: this.get('stretch'),
            assetId: this.get('assetId'),
            tabEnabled: this.get('tabEnabled'),
            gridData: this.get('gridData'),
            tableRowHeight: this.get('tableRowHeight'),
            tableRowMax: this.get('tableRowMax'),
            showHeader: this.get('showHeader'),
            headerHeight: this.get('headerHeight'),
            showButtons: this.get('showButtons'),
            resizableColumns: this.get('resizableColumns'),
            showFooter: this.get('showFooter')
        };

        this.initDevicePhone = {
            top: this.get('top'),
            left: this.get('left'),
            height: this.get('height'),
            width: this.get('width'),
            isHidden: this.get('isHidden'),
            tabIndex: this.get('tabIndex'),
            tabSettingsTitle : 'Settings',
            displayMode: '- Phone',
            maintainAspectRatio: this.get('maintainAspectRatio'),
            stretch: this.get('stretch'),
            assetId: this.get('assetId'),
            tabEnabled: this.get('tabEnabled'),
            gridData: this.get('gridData'),
            tableRowHeight: this.get('tableRowHeight'),
            tableRowMax: this.get('tableRowMax'),
            showHeader: this.get('showHeader'),
            headerHeight: this.get('headerHeight'),
            showButtons: this.get('showButtons'),
            resizableColumns: this.get('resizableColumns'),
            showFooter: this.get('showFooter')
        };

        this.set({
            pageID: formModel.get('currentPage'),

            deviceDesktop: this.initDevice,
            deviceTablet: this.initDeviceTablet,
            devicePhone: this.initDevicePhone,
            trackEnabled: true


        });
//Removing this line to avoid circular references, found when pasting inside groups
        //controlCollection.add(this);

        this.on('change:gridData', function(){
            // only set on device specific for Table Control
            if (this.get('factoryKey') === 'control_table') {
                //this.set({[formModel.get('currentDevice')]: {gridData: this.get('gridData')}});
                this.get(formModel.get('currentDevice')).gridData = this.get('gridData');
            }
        });

        this.on('change:assetId', function(){
            if (this.get('factoryKey') === 'control_picture') {
                //Copy assetId to all the other devices
                this.get(constants.MOBILE_DEVICE_PHONE).assetId = this.get('assetId');
                this.get(constants.MOBILE_DEVICE_TABLET).assetId = this.get('assetId');
                this.get(constants.MOBILE_DEVICE_DESKTOP).assetId = this.get('assetId');
            }
        });
       
        var control = this;
        formModel.on('change:currentDevice', function() {
            //control.set( 'currentDevice', this.get('currentDevice') , {silent:true});
            control.set( control.attributes[this.attributes.currentDevice] , {silent:true});
            console.log(`controlModel.currentDevice ${control.get('currentDevice')}`);           
        });

        
        const listToChanges = ['showFooter', 'resizableColumns', 'showButtons',
            'headerHeight', 'showHeader', 'tableRowMax', 'tableRowHeight',
            'tabEnabled', 'assetId', 'stretch', 'maintainAspectRatio', 'tabIndex', 'isHidden',
            'width', 'height', 'left', 'top'];

        /**
         * TODO implement undo for checkbox group and radio group
         *
         * Checkbox groups and Radio button groups hold reference to child views on childList
         * creating circular references which cannot be serialized
         */

        this.lastState(this.toJSON());

        this.set('undoAction', false, {silent: true});

        this.on('loadRelatedPages', () => {
            this.getRelatedPages();
        });

        this.on('change', (model, changed, options) => {

            this.getRelatedPages();

            const undoRedoCommonFn = (aState, mapReviver) => {
                // Load the saved version
                this.set(JSON.parse(aState, mapReviver), {silent: true});

                // Ignore what was set for this, this is important to not register another undo
                this.set('undoAction', true, {silent: true});

                // Refresh rendered control name in page's thumbnail
                eventBus.trigger(constants.EV_RENAME_OBJECT_PAGE, this.get('id'), this.get('name'));
                
                // Refresh the breadcrumb
                const breadCrumbType = this.get('factoryKey') === 'page_instance' ? 'PAGE' : 'OBJECT';
                eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, breadCrumbType, this.get('id'));

                // Trigger change because all views listening need to update
                this.trigger('change');
            };

             if (this.get('factoryKey') === 'control_list') {
                  let x = this.get('gridData');
                  this.initDevice.gridData = x;
                  this.initDeviceTablet.gridData = x;
                  this.initDevicePhone.gridData = x;
             }//
        // the initial setting of the properties set those for all devices
        // any subsequent position change is only for the current device

          // #PF-2941
          //Changing to this.attributes instead of this.changed, as the changes made with silent:true
          // on ResizeController are not being tracked on this.changes.
          // I iterate the whole properties instead
            _.map(this.attributes, (value, key) => {
                if (listToChanges.indexOf(key) !== -1) {
                    this.get(formModel.get('currentDevice'))[key] = value;
                }
            });

             // #PF-3465
             // Omitting table control to property change routine that is fired of every control model change.
            if (this.get('factoryKey') === 'control_table') {
                
                const lastState = JSON.parse(this._lastState).gridData;
                const currentState = this.gridData;
                
                undoService.add({
                    undo: () => {
                        this.gridData = lastState;
                        this.trigger('change');
                    },
                    redo: ()=>{
                        this.gridData = currentState;
                        this.trigger('change');
                    }
                }, textConstants.UNDO_MOVE);

                this.set('undoAction', false, {silent: true});
                return;
            }

            if(this.get('undoAction')){
                this.lastState(this.toJSON());
                this.set('undoAction', false, {silent: true});
            } else {
                const lastState = this._lastState;
                const newState = JSON.stringify(this);

                undoService.add({
                    undo: () => {
                        undoRedoCommonFn(lastState, this.mapReviver);
                    },
                    redo: ()=>{
                        undoRedoCommonFn(newState, this.mapReviver);
                    }
                }, textConstants.UNDO_MOVE);

                this.lastState(this.toJSON());
            }
        });

    }

    get mapReviver(){
        return (key, value) => {
            var serializedValue = value;
            if(key === 'mandatories' || key === 'state' ){
                serializedValue = new Map(value);
            }
            return serializedValue;
        };
    }
    lastState(state){
        this._lastState = JSON.stringify(state);
    }

    defaults() {
        return {
        };
    }

    parse(response, options)  {
        return response;
    }

    resetLastState() {
        this.lastState(this.toJSON());
    }

    triggerChangeNoTracking() {
        this.set('undoAction', true, {silent: true});
        this.trigger('change');
    }

    //PF-6630 get the related pages to print and show buttons in case the page is deleted the corresponding modal is displayed and references are removed
    getRelatedPages(){

        const factoryKey = this.get("factoryKey");
        this.set("relatedPages", "", {silent:true});

        if(factoryKey === "control_page_button" || factoryKey === "control_print_button"){
          
            if (this.get("pageType") === "specific") {

                 //Reset values
                const relatedPages = [];
              
                const addField = (id) => {
                    if(!relatedPages.includes(id)){
                        relatedPages.push(listService.cleanId(id)) 
                    }
                };
                
                //Show page button
                if (this.get("page")) {
                    addField(this.get("page"));
                }

                //Print button
                if (this.get("pageIds")) {
                    const pages = this.get("pageIds").split(",");
                    _.each(pages, (page) => {
                        addField(page);
                    });
                }
                this.set("relatedPages", relatedPages, {silent: true});
            }           
        }
    }
}


export default ControlModel;
